import { useState, useEffect } from "react";
import { ArrowUp } from "lucide-react";

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <button
      onClick={scrollToTop}
      className={`fixed bottom-20 right-6 z-50 p-3 bg-emerald-900 hover:bg-emerald-800 text-amber-400 rounded-full shadow-lg transition-all duration-300 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'
      }`}
      style={{ 
        boxShadow: '0 4px 15px rgba(0, 0, 0, 0.3)',
        border: '2px solid rgba(251, 191, 36, 0.5)'
      }}
      data-testid="scroll-to-top-btn"
      aria-label="Scroll to top"
    >
      <ArrowUp className="h-6 w-6" style={{ filter: 'drop-shadow(0 0 2px rgba(251, 191, 36, 0.5))' }} />
    </button>
  );
};

export default ScrollToTopButton;
